import { getProductListDetailNavLinks } from '@/modules/product/components/productListDetailNavLinks';
import { NavLink } from 'react-router-dom';

interface ProductListDetailNavProps {
  productListId: string;
}

const ProductListDetailNav = ({ productListId }: ProductListDetailNavProps) => {
  const links = getProductListDetailNavLinks(productListId);

  return (
    <nav aria-label="Product List management" className="mb-8 overflow-x-auto">
      <ul className="flex min-w-max gap-2 border-b border-gray-200" role="list">
        {links.map(({ label, to, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `inline-flex border-b-2 px-3 py-2 text-sm font-medium transition-colors focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900'
                }`
              }
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ProductListDetailNav;
